import { createAction, props } from '@ngrx/store';
import { TicketsScope } from "./tickets.model";
import { HttpErrorState } from '../shared/error.models';

/**
 * The following might be obsolete and have not been moved to NGRX:
 * getFilters | getShared | getCrossSell | getSummary
 *
 * Also, the inStore ones haven't been tested.
 */

export type ListType = 'single' | 'syndicate' | 'group';

// Confirmed with backend team
export interface TicketCreatePayload {
  ticket: {
    channel: string;
    cost: string;
    cross_sell: number;
    currency: string;
    free_play_id: null | string;
    pool_id: number;
    selections: string;
    smartpick: number;
    stake: string;
    use_bonus_funds: boolean;
  };
}

// Create ticket (betslip)

export const createTicket = createAction('[Tickets] Create ticket',
  props<{
    model?: TicketCreatePayload
  }>());

export const setUnauthSecurityCode = createAction('[Tickets] Unauth Set Security Code',
  props<{
    securityCode: string
  }>());

// Confirmed with backend team
export interface TicketCreateResponse {
  id: string;
  merchant_ref: string;
  selections: string;
  stake: string;
  cost: string;
  currency: string;
  cross_sell_suggestion: null | unknown;
  security_code: null | string;
  syndicate: null | unknown;
}

export const successCreateTicket = createAction('[Tickets] Success create ticket',
  props<{
    model?: TicketCreateResponse
  }>());

// Individual tickets
export const callSoloTicket = createAction('[Ticket] Call solo ticket',
props<{
  ticket_id: string
}>());

export const callSyndicateTicket = createAction('[Ticket] Call syndicate ticket',
props<{
  portion_id: number | string
}>());

export const callGTTicket = createAction('[Ticket] Call GT ticket',
props<{
  pool_id: number,
  manager_id: number | string
}>());

export const successTicket = createAction('[Ticket] Success ticket',
props<{
  response: TicketsScope.TicketItem
}>());

export const successGTTicket = createAction('[Ticket] Success GT ticket',
props<{
  response: TicketsScope.GroupTicketItem
}>());

// Tickets list

// TODO: Define TicketListFilters interface after confirming filter structure with backend team
export interface TicketListFilters {
  is_solo_bet?: boolean;
  with_offer?: boolean;
  status?: 'live' | 'placed' | 'historic' | 'void' | string;
  pool_types?: string | string[];
  [key: string]: unknown;
}

/**
 * Default filters applied when navigating to a ticket list route without query params.
 * The smart container uses these to redirect to a canonical URL with defaults.
 * The Effect also uses these to enrich pool_types when they are not in the URL.
 */
export const TICKET_LIST_DEFAULT_FILTERS: Record<
  'single' | 'syndicates',
  Required<Pick<TicketListFilters, 'status' | 'is_solo_bet' | 'with_offer'>>
> = {
  single:     { status: 'live', is_solo_bet: true,  with_offer: false },
  syndicates: { status: 'live', is_solo_bet: false, with_offer: false },
};

export interface TicketListParams {
  page?: number;
  per?: number;
  type?: string;
  filters?: TicketListFilters;
}

export const callTicketList = createAction('[Tickets] Call ticket list',
props<{
  model?: TicketListParams
}>());

export const loadTicketList = createAction('[Tickets] Load tickets list',
  props<{
    model?: TicketListParams
  }>());

export const successList = createAction('[Tickets] Success ticket list',
props<{
  response: TicketsScope.TicketList
}>());

export const listLoadMore = createAction('[Tickets] Load more tickets list');

// Syndicate list

export const callSyndicateTicketList = createAction('[Tickets] Call syndicate ticket list',
  props<{
    model?: TicketListParams
  }>());

export const loadSyndicateTicketList = createAction('[Tickets] Load syndicate tickets list',
  props<{
    model?: TicketListParams
  }>());

export const syndicateListLoadMore = createAction('[Tickets] Load more syndicate tickets list');

// GT list

export const callGTList = createAction('[Tickets] Call group ticket list',
  props<{
    model?: TicketListParams
  }>());

export const successGTList = createAction('[Tickets] Success group ticket list',
  props<{
    response: TicketsScope.TicketList
  }>());

export const loadGTTicketList = createAction('[Tickets] Load GT tickets list',
  props<{
    model?: TicketListParams
  }>());

export const gtTicketListLoadMore = createAction('[Tickets] Load more GT tickets list');
//

export const loadListDispatcher = createAction('[Tickets] Load list dispatcher',
  props<{
    // TODO: Define proper dispatcher payload structure
    extra?: unknown
    filters?: TicketListFilters
}>());

export const loadMoreDispatcher = createAction('[Tickets] Load more dispatcher');

// Share

// TODO: Define ShareTicketPayload and Response after confirming with backend team
export interface ShareTicketPayload {
  ticket_id: string | number;
  [key: string]: unknown;
}

export const shareTicket = createAction('[Ticket] Call share ticket',
props<{
  model?: ShareTicketPayload
}>());

export const successShareTicket = createAction('[Ticket] Success share ticket',
  props<{
    model?: unknown
  }>());

// Instore and others....

export const callUnAuthTicket = createAction('[inStore] Call unAuth ticket',
  props<{
    merchant_ref: string,
    security_code?: string
  }>());

  export const callInstoreTicket = createAction('[inStore] Call inStore ticket',
props<{
  merchant_ref: string,
  security_code?: string
}>());

// NOTE: InStore ticket actions are deprecated but kept for backward compatibility
// These will be updated in future when in-store functionality is refactored
export const successInstoreTicket = createAction('[inStore] Success inStore ticket',
props<{
  model?: unknown // Deprecated - will be defined when feature is updated
}>());

export const updateSecurityCode = createAction('[inStore] Update security code',
props<{
  merchant_ref: string,
  body: unknown // Deprecated - will be defined when feature is updated
}>());

export const successSecurityCode = createAction('[inStore] Success security code',
props<{
  model?: unknown
}>());

export const callMarkAsPaid = createAction('[inStore] Call mark as paid',
props<{
  merchant_ref: string,
  body: unknown // Deprecated - will be defined when feature is updated
}>());

export const successMarkAsPaid = createAction('[inStore] Success mark as paid',
props<{
  model?: unknown
}>());

// errors

export const failTicket = createAction('[Ticket] Fail',
  props<{
    error: HttpErrorState
  }>());

export const failTicketList = createAction('[Ticket] List Fail',
  props<{
    error: HttpErrorState
  }>());


export const failGTTicketList = createAction('[Ticket] GT List Fail',
  props<{
    error: HttpErrorState
  }>());

// Other ticket-related actions
export const clearCurrentTicket = createAction(
  '[Tickets] Clear Current Ticket'
);

export const clearGroupTicket = createAction(
  '[Tickets] Clear Group Ticket'
);

export const setTicketLoadError = createAction(
  '[Tickets] Set Load Error',
  props<{ error: boolean }>()
);

/**
 * Dispatched by the Smart Container (TicketsListView) whenever the URL changes.
 * The Effect picks this up, enriches pool_types from the NgRx pool filters if absent,
 * and routes to either loadTicketList or loadSyndicateTicketList.
 *
 * `contentType` is the user-selected content category (e.g. 'RACING', 'FOOTBALL', 'ALL').
 * It is UI-only (never sent to the API) but tells the Effect which pool typse bucket to
 * use when `pool_types` is absent from the URL. When undefined, the configuration's
 * global displayState.view is used as fallback.
 *
 * This replaces the brittle global routerNavigatedAction handler.
 */
export const loadTicketListFromRoute = createAction(
  '[Tickets List] Load From Route',
  props<{
    listType: 'single' | 'syndicates';
    filters: TicketListFilters;
    contentType?: string;
  }>()
);
